import { World } from '$legacyecstatic';
import { Components } from 'editor/components';
import { EditorTools } from 'editor/components/Tool';
import noop from 'lodash/noop';
import textKeyboardEvents from './textKeyboardEvents';

export interface KeyboardEventArgs {
  world: World<Components>;
  evt: KeyboardEvent; // update this.
}

export interface KeyboardToolEvents {
  keydown: (args: KeyboardEventArgs) => void;
  keyup: (args: KeyboardEventArgs) => void;
}

export interface KeyboardEventHandlers {
  [EditorTools.Pointer]: KeyboardToolEvents;
  [EditorTools.DrawRectangle]: KeyboardToolEvents;
  [EditorTools.DrawLine]: KeyboardToolEvents;
  [EditorTools.DrawArrow]: KeyboardToolEvents;
  [EditorTools.DrawText]: KeyboardToolEvents;
  [EditorTools.CreatePunch]: KeyboardToolEvents;
  [EditorTools.PostRFI]: KeyboardToolEvents;
}

const defaultKeyboardEvents: KeyboardToolEvents = {
  keydown: noop,
  keyup: noop,
};

const keyboardEventHandlers: KeyboardEventHandlers = {
  [EditorTools.Pointer]: textKeyboardEvents,
  [EditorTools.DrawRectangle]: defaultKeyboardEvents, // unimplemented
  [EditorTools.DrawLine]: defaultKeyboardEvents, // unimplemented
  [EditorTools.DrawArrow]: defaultKeyboardEvents, // unimplemented
  [EditorTools.DrawText]: textKeyboardEvents,
  [EditorTools.CreatePunch]: defaultKeyboardEvents, // unimplemented
  [EditorTools.PostRFI]: defaultKeyboardEvents, // unimplemented
};

export default keyboardEventHandlers;
